module.exports = __webpack_public_path__ + "static/media/quicicon-07.6a68af50.png";